module.exports = __webpack_public_path__ + "media/images/banner/japanesecrafts/banner-6efa26c52ad398b0259a18d56caa8566.jpg";